import { useEffect, useState, type FormEvent } from 'react';
import { Modal } from './Modal';

interface ConfirmNoteModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  noteLabel?: string;
  notePlaceholder?: string;
  noteRequired?: boolean;
  busy?: boolean;
  onConfirm: (note: string) => void | Promise<void>;
  onCancel: () => void;
}

export function ConfirmNoteModal({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  noteLabel = 'Optional note',
  notePlaceholder = 'Add a note (optional)',
  noteRequired = false,
  busy = false,
  onConfirm,
  onCancel
}: ConfirmNoteModalProps) {
  const [note, setNote] = useState('');

  useEffect(() => {
    if (open) setNote('');
  }, [open]);

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    const trimmed = note.trim();
    if (noteRequired && !trimmed) return;
    await onConfirm(trimmed);
  };

  return (
    <Modal
      open={open}
      title={title}
      size="sm"
      onClose={onCancel}
      closeDisabled={busy}
      asForm
      onSubmit={(event) => void handleSubmit(event)}
      actions={
        <>
          <button type="button" className="ghost-btn" disabled={busy} onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="primary-btn" disabled={busy}>
            {busy ? 'Working…' : confirmLabel}
          </button>
        </>
      }
    >
      <p className="confirm-note-message">{message}</p>
      <label>
        {noteLabel}
        <textarea
          rows={3}
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder={notePlaceholder}
          required={noteRequired}
          disabled={busy}
        />
      </label>
    </Modal>
  );
}
